// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex/store.js'

Vue.http.options.emulateHTTP = true;
Vue.http.options.emulateJSON = true;

Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.innerText
    el.remove()
  }
})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>',
})

router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
})



// WEBPACK FOOTER //
// ./src/main.js